/** The theme's page column, with the classic width for anything outside a themed shell. */
export const PAGE_MAX = 'var(--storefront-container-max, 72rem)';

/**
 * A merchant's content width - a percentage of the page column, or of the
 * screen where that is narrower - as a CSS length. See `contentWidthFor`.
 */
export function contentWidthLength(percent: number): string {
  return `calc(min(${PAGE_MAX}, 100%) * ${percent / 100})`;
}
